import './kp-login.less';
import type LoginService from '../login.service';
import type LoginDataService from './kp-login.data-service';
import type {IOnInit} from 'angular';
import type {AuthenticationSystemView, LoginView} from './kp-login';
import type ModalLoginController from '../../../modals/controllers/modal-login.controller';
import type MainLoginFormService from '../main-login-form-service';
import KpLoadingBlock from '../../components/kp-loading/KpLoadingBlock.svelte';
import {ngAsync} from 'shared/utils/ng-@decorators';

export class LoginComponentController implements IOnInit {
    public visibleAuthSystems: AuthenticationSystemView[];
    public loginView: LoginView;
    public modalLoginFormController: ModalLoginController;
    public kpLoadingBlockComponent = KpLoadingBlock;

    /*@ngInject*/
    constructor(private loginDataService: LoginDataService, private loginService: LoginService, private mainLoginFormService: MainLoginFormService) {
    }

    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    @ngAsync()
    public async $onInit() {
        this.loginView = await this.loginDataService.getLoginView();
        this.visibleAuthSystems = this.loginView.authSystemViews.filter((authSystem) => authSystem.showingInMainLogin);
    }

    public showError(): boolean {
        return this.mainLoginFormService.isError();
    }

    public getErrorMessage() {
        return this.mainLoginFormService.getError();
    }

    public showProcessing(): boolean {
        return this.mainLoginFormService.isProcessing();
    }
}

/**
 * @ngdoc component
 * @name kpLogin
 * @module portaro.login
 *
 * @param modalLoginFormController Tohle je tady fakt potreba... TODO: Refactor this
 *
 * @description Login forms generation
 */

export default class LoginComponent {
    public static componentName = 'kpLogin';

    public templateUrl = require('./kp-login.tpl.ftl');

    public controller = LoginComponentController;

    public bindings = {
        modalLoginFormController: '<'
    };
}
